const userWorkerRoutes = [
];


export default userWorkerRoutes;
